<template>
    <div>
         <modal :show.sync="addObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar Obligación financiera</h6>
                <div class="form-group">
                    <label>Tipo de crédito *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="obligationType">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationType">
                                    <el-option v-for="obligationType in $store.getters.getFinancialObligationTypes" :key="obligationType.id"
                                            class="select-warning"
                                            :value="obligationType.name"
                                            :label="obligationType.name">
                                    </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Entidad *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="Entidad"
                                placeholder="Entidad"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('Entidad')"
                                v-model="obligationEntity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Rol *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="obligationRole">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationRole">
                            <el-option
                                    class="select-warning"
                                    value="Titular"
                                    label="Titular">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Codeudor cónyuge"
                                    label="Codeudor cónyuge">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo de cuenta *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="obligationAccountType">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationAccountType">
                            <el-option v-for="accountType in $store.getters.getAccountTypes" :key="accountType.code"
                                    class="select-warning"
                                    :value="accountType.code"
                                     :label="`(${accountType.code})-${accountType.name}`">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto del crédito *</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationAmountCredit"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Saldo / Central de riesgo</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligationResidue" :error="getError('valor')" separator="." class="form-control" v-model="obligationResidue"></vue-numeric>
                </div>
                <!-- <div v-if="parseInt(obligationAmountCredit) < parseInt(obligationResidue)" class="alert alert-danger mt-2">
                    <span>El monto no puede ser menor al saldo</span>
                </div> -->
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Saldo contingente TDC *</label>
                    <vue-numeric  disabled :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationContingentResidueComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Cuota / Central de riesgo *</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationQuota"></vue-numeric>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Cuota contigente TDC *</label>
                    <vue-numeric  disabled :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationContingentQuotaComputed"></vue-numeric>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Valor de Cuota Flujo de Crédito *</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationQuotaCreditFlow" @change="changeCreditFlow()"></vue-numeric>
                    <p-button v-show="manualQuotaOverride != ''" type="info" @click="resetObligationQuotaCreditFlow()">Recalcular Cuota</p-button>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Saldo flujo de crédito *</label>
                    <vue-numeric  disabled :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationResidueCreditFlowComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   tabindex="0"
                                type="number"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_term"
                                :error="getError('plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label># Cuotas pendientes *</label>
                    <fg-input   tabindex="0"
                                type="number"
                                name="cuotas pendientes"
                                placeholder="cuotas pendientes"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_term"
                                :error="getError('cuotas pendientes')"
                                v-model="obligationPendingQuota">
                    </fg-input>
                </div>
                <div v-if="parseInt(obligationPendingQuota) > parseInt(obligationTerm)" class="alert alert-danger mt-2">
                    <span>Las cuotas pendientes no pueden ser mayores al plazo</span>
                </div>
                <div class="form-group">
                    <label>% Cuotas *</label>
                    <fg-input   disabled
                                tabindex="0"
                                type="number"
                                name="porcentaje de cuotas"
                                placeholder="porcentaje de cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('porcentaje de cuotas')"
                                v-model="obligationPendingPercentComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="obligationPeriodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationPeriodicity">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Destino *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="Destino"
                                placeholder="Destino"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('Destino')"
                                v-model="obligationDestiny">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Recoger *</label>
                    <fg-input   name="recoger"
                                v-validate="modelValidations.periodicity"
                                :error="getError('recoger')"
                                v-model="obligationCollect">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationCollect">
                            <el-option
                                    class="select-warning"
                                    value="Si"
                                    label="Si">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="No"
                                    label="No">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Destino del crédito *</label>
                    <fg-input   name="destino"
                                v-validate="modelValidations.periodicity"
                                :error="getError('destino')"
                                v-model="obligationCreditDestiny">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationCreditDestiny">
                            <el-option
                                    class="select-warning"
                                    value="Capital de trabajo"
                                    label="Capital de trabajo">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Activo fijo"
                                    label="Activo fijo">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addObligationToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar Obligación financiera</h6>
                <div class="form-group">
                    <label>Tipo de crédito *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="obligationType">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationType">
                                    <el-option v-for="obligationType in $store.getters.getFinancialObligationTypes" :key="obligationType.id"
                                            class="select-warning"
                                            :value="obligationType.name"
                                            :label="obligationType.name">
                                    </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Entidad *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="Entidad"
                                placeholder="Entidad"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('Entidad')"
                                v-model="obligationEntity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Rol *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="obligationRole">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationRole">
                            <el-option
                                    class="select-warning"
                                    value="Titular"
                                    label="Titular">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Codeudor cónyuge"
                                    label="Codeudor cónyuge">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo de cuenta *</label>
                    <fg-input   name="tipo de cuenta"
                                v-validate="modelValidations.periodicity"
                                :error="getError('tipo de cuenta')"
                                v-model="obligationAccountType">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationAccountType">
                            <el-option v-for="accountType in $store.getters.getAccountTypes" :key="accountType.code"
                                    class="select-warning"
                                    :value="accountType.code"
                                     :label="`(${accountType.code})-${accountType.name}`">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto del crédito *</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationAmountCredit"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Saldo / Central de riesgo</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligationResidue" :error="getError('valor')" separator="." class="form-control" v-model="obligationResidue"></vue-numeric>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Saldo contingente TDC *</label>
                    <vue-numeric  disabled :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationContingentResidueComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Cuota / Central de riesgo *</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationQuota"></vue-numeric>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Cuota contigente TDC *</label>
                    <vue-numeric  disabled :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationContingentQuotaComputed"></vue-numeric>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Valor de Cuota Flujo de Crédito *</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationQuotaCreditFlow" @change="changeCreditFlow()"></vue-numeric>
                    <p-button v-show="manualQuotaOverride != ''" type="info" @click="resetObligationQuotaCreditFlow()">Recalcular Cuota</p-button>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Saldo flujo de crédito *</label>
                    <vue-numeric  disabled :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationResidueCreditFlowComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   tabindex="0"
                                type="number"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_term"
                                :error="getError('plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label># Cuotas pendientes *</label>
                    <fg-input   tabindex="0"
                                type="number"
                                name="cuotas pendientes"
                                placeholder="cuotas pendientes"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_term"
                                :error="getError('cuotas pendientes')"
                                v-model="obligationPendingQuota">
                    </fg-input>
                </div>
                <div v-if="parseInt(obligationPendingQuota) > parseInt(obligationTerm)" class="alert alert-danger mt-2">
                    <span>Las cuotas pendientes no pueden ser mayores al plazo</span>
                </div>
                <div class="form-group">
                    <label>% Cuotas *</label>
                    <fg-input   disabled
                                tabindex="0"
                                type="number"
                                name="porcentaje de cuotas"
                                placeholder="porcentaje de cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('porcentaje de cuotas')"
                                v-model="obligationPendingPercentComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('periodicidad')"
                                v-model="obligationPeriodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationPeriodicity">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Destino *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="Destino"
                                placeholder="Destino"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('Destino')"
                                v-model="obligationDestiny">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Recoger *</label>
                    <fg-input   name="recoger"
                                v-validate="modelValidations.periodicity"
                                :error="getError('recoger')"
                                v-model="obligationCollect">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationCollect">
                            <el-option
                                    class="select-warning"
                                    value="Si"
                                    label="Si">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="No"
                                    label="No">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Destino del crédito *</label>
                    <fg-input   name="destino"
                                v-validate="modelValidations.periodicity"
                                :error="getError('destino')"
                                v-model="obligationCreditDestiny">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationCreditDestiny">
                            <el-option
                                    class="select-warning"
                                    value="Capital de trabajo"
                                    label="Capital de trabajo">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Activo fijo"
                                    label="Activo fijo">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editObligationToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>

        <!-- Vehicles -->
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Obligaciones financieras</h6>
            </div>
            <div class="card-body">
                <el-table v-if="actualObligations.length" :data="actualObligations"  ref="vehiclesTable"  @row-dblclick="showEditObligationMethod" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div>
                                <p><strong>Tipo de Obligación:</strong> {{ props.row.obligationType }}</p>
                                <p><strong>Entidad de la Obligación:</strong> {{ props.row.obligationEntity }}</p>
                                <p><strong>Rol:</strong> {{ props.row.obligationRole }}</p>
                                <p><strong>Tipo de Cuenta:</strong> {{ props.row.obligationAccountType }}</p>
                                <p><strong>Monto de Crédito:</strong> {{ setFormat(props.row.obligationAmountCredit) }}</p>
                                <p><strong>Saldo de Obligación:</strong> {{ setFormat(props.row.obligationResidue) }}</p>
                                <p><strong>Cuota:</strong> {{ setFormat(props.row.obligationQuota) }}</p>
                                <p><strong>Plazo:</strong> {{ props.row.obligationTerm }}</p>
                                <p><strong>Cuota Pendiente:</strong> {{ setFormat(props.row.obligationPendingQuota) }}</p>
                                <p><strong>Porcentaje Pendiente:</strong> {{ setFormat(props.row.obligationPendingPercent) }}</p>
                                <p><strong>Periodicidad:</strong> {{ props.row.obligationPeriodicity }}</p>
                                <p><strong>Destino de la Obligación:</strong> {{ props.row.obligationDestiny }}</p>
                                <p><strong>Recoger:</strong> {{ props.row.obligationCollect }}</p>
                                <p><strong>Destino del Crédito:</strong> {{ props.row.obligationCreditDestiny }}</p>

                                <!-- Mostrar los campos adicionales solo si el tipo de cuenta es 'TDC' -->
                                <div v-if="props.row.obligationAccountType === 'TDC'">
                                    <p><strong>Residuo Contingente:</strong> {{ setFormat(props.row.obligationContingentResidue) }}</p>
                                    <p><strong>Cuota Contingente:</strong> {{ setFormat(props.row.obligationContingentQuota) }}</p>
                                    <p><strong>Flujo de Cuota de Crédito:</strong> {{ setFormat(props.row.obligationQuotaCreditFlow) }}</p>
                                    <p><strong>Flujo de Saldo de Crédito:</strong> {{ setFormat(props.row.obligationResidueCreditFlow) }}</p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Entidad" property="obligationEntity"></el-table-column>
                    <el-table-column label="Saldo">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.obligationResidue)}}</span>
                        </template>
                    </el-table-column>
                </el-table>

                <div>
                    <p-button
                        @click="addObligationMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar obligación
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editObligationMethod(currentRow)"
                        type="default"
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar obligación
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeObligationMethod()"
                        type="default"
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar obligación
                    </p-button>
                </div>
                <div v-if="obligationTotalComputed != 0" class="alert alert-warning mt-2">
                    <span>Total obligaciones : {{setFormat(obligationTotalComputed)}}</span>
                </div>
                <div v-if="obligationCAV != null && obligationCAV != 0" class="alert alert-info mt-2">
                    <span>Total obligaciones CAV : {{setFormat(obligationCAV)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <p-button v-if="obligationTotalComputed != 0" @click="saveObligations()" type="warning">Siguiente</p-button>
            <p-button @click="toSalesCostsSelection()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import Expenses from 'src/util/Services/Expenses'
    import Travels from 'src/util/Services/Travels'
    import Taxes from 'src/util/Services/Taxes'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            form: {
                average_selection: '',
            },
            manualQuotaOverride: '',
            contingentQuota: null,
            clientType: null,
            obligationType: '',
            obligationEntity: '',
            obligationRole: '',
            obligationAccountType: '',
            obligationAmountCredit: '',
            obligationResidue: '',
            obligationQuota: '',
            obligationContingentResidue: '',
            obligationContingentQuota: '',
            obligationQuotaCreditFlow: '',
            obligationResidueCreditFlow: '',
            obligationTerm: '',
            obligationPendingQuota: '',
            obligationPendingPercent: '',
            obligationPeriodicity: '',
            obligationDestiny: '',
            obligationCollect: '',
            obligationCreditDestiny: '',
            obligationCAV: null,
            obligationTotalBusiness: null,
            obligationResidueBusiness: null,
            obligationQuotaBusiness: null,
            obligationPendingPercentBusiness: null,
            obligationTotalFamiliar: null,
            obligationResidueFamiliar: null,
            obligationQuotaFamiliar: null,
            obligationPendingPercentFamiliar: null,
            alertFlag: true,
            periodicity: '',
            periodicityFlag: true,
            periodicityDaysFlag: true,
            periodicity_days: 0,
            vehicles : [],
            travels : [],
            expenses : [],
            taxes: [],
            obligations: [],
            actualObligations: [],
            actualVehicles: [],
            actualTravels: [],
            actualExpenses: [],
            actualTaxes: [],
            currentRow: null,
            currentTaxRow: null,
            currentTravelRow: null,
            currentExpenseRow: null,
            addExpense: false,
            editExpense: false,
            addObligation: false,
            editObligation: false,
            addTravel: false,
            editTravel: false,
            addTax: false,
            editTax: false,
            addObligationIndex: null,
            monthlyNumber: '',
            vehicleName: '',
            vehicleValue: '',
            vehicleLocked: false,
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            travelName: '',
            travelValue: '',
            travelLocked: false,
            taxName: '',
            taxValue: '',
            taxPeriodicity: '',
            taxLocked: false,
            products: [

            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                obligationResidue: {
                  required: false
                },
                sales: {
                    required: false
                },
                product_name: {
                    required: false,
                    max: 32
                },
                item_costs: {
                    required: true,
                    min: 1,
                    max: 28
                },
                average_selection: {
                    required: false
                },
                item_name: {
                    required: false,
                    max: 32
                },
                obligation_term: {
                    required: false,
                    max: 3
                }
            },
        }
        },
        watch: {
            obligationContingentQuota(newVal, oldVal) {
                this.updateCreditFlow();
            },
            obligationQuota(newVal, oldVal) {
                this.updateCreditFlow();
            },
            obligationCreditDestiny(newVal){
                if(this.obligationType){
                    if(this.obligationType == 'OTRAS OBLIGA'){
                        if(newVal == 'Capital de trabajo'){
                            this.showNotificationError('Destino no válido');
                            this.obligationCreditDestiny = null;
                        }
                    }
                    else if(this.obligationType == 'PROVEEDOR'){
                        if(newVal == 'Activo fijo'){
                            this.showNotificationError('Destino no válido');
                            this.obligationCreditDestiny = null;
                        }
                    }
                }
            },
            obligationType(newVal){
                const currentAssessment = this.$store.state.assesments[this.$store.state.actualAssesment];
                if(this.$store.state.isCustomer){
                    if(currentAssessment.customer.actualStudy > 0){
                        if(newVal == "UNID FLIAR"){
                            this.showNotificationError('No puedes seleccionar este tipo de crédito');
                            this.obligationType = null;
                            return
                        }
                    }
                }
                else if(this.$store.state.isSpouse){
                    // if(currentAssessment.customerSpouse.actualStudy > 0){
                    //     if(newVal == "UNID FLIAR"){
                    //         this.showNotificationError('No puedes seleccionar este tipo de crédito');
                    //         this.obligationType = null;
                    //         return
                    //     }
                    // }
                    if(newVal == "UNID FLIAR"){
                        this.showNotificationError('No puedes seleccionar este tipo de crédito');
                        this.obligationType = null;
                        return
                    }
                }
                else if(this.$store.state.isGuarantor){
                    if(currentAssessment.guarantors[currentAssessment.actualGuarantors].actualStudy > 0){
                        if(newVal == "UNID FLIAR"){
                            this.showNotificationError('No puedes seleccionar este tipo de crédito');
                            this.obligationType = null;
                            return
                        }
                    }
                }
            },
            obligationAccountType(newVal) {

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity_days: function(newVal, oldVal) {
                if(newVal < 0) {
                    this.periodicity_days = 1;
                }
                else if(newVal > 7) {
                    this.periodicity_days = 7;
                }
                else if(newVal == '') {
                    this.periodicity_days = 0;
                }
                else {
                    this.periodicity_days = parseFloat(newVal)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity: function(newVal, oldVal) {

                if (oldVal != '') {
                    this.periodicity_days = 0;
                }
            }
        },
        computed: {
            // obligationTotalComputed () {
            //     // Verifica si actualObligations es un array y no está vacío
            //     if (Array.isArray(this.actualObligations) && this.actualObligations.length > 0) {
            //     return this.actualObligations.reduce((total, obligation) => {
            //         // Suma el valor de obligationResidue si está definido, de lo contrario, suma 0
            //         return total + (parseFloat(obligation.obligationResidue) || 0);
            //     }, 0);
            //     }
            //     return 0; // Si no hay obligaciones, el total es 0
            // },
            obligationTitularComputed () {
                let totalGeneral = 0;
                // Verifica si actualObligations es un array y no está vacío
                if (Array.isArray(this.actualObligations) && this.actualObligations.length > 0) {
                this.actualObligations.forEach(obligation => {
                    const residue = parseFloat(obligation.obligationResidue) || 0;

                    if (obligation.obligationRole === "Titular" && obligation.obligationAccountType !== "CAV") {
                    totalGeneral += residue;
                    }
                });
                }
                return totalGeneral;
            },
            obligationTotalComputed () {
                let totalGeneral = 0;
                let obligationCAV = 0;
                let obligationTotalBusiness = 0;
                let obligationTotalFamiliar = 0;
                let obligationResidueBusiness = 0;
                let obligationResidueFamiliar = 0;
                let obligationQuotaBusiness = 0;
                let obligationQuotaFamiliar = 0;
                let obligationPendingPercentBusiness = 0;
                let obligationPendingPercentFamiliar = 0;
                // Contadores para el promedio
                let countFamiliar = 0;
                let countBusiness = 0;

                // Verifica si actualObligations es un array y no está vacío
                if (Array.isArray(this.actualObligations) && this.actualObligations.length > 0) {
                this.actualObligations.forEach(obligation => {
                    const residue = parseFloat(obligation.obligationResidue) || 0;
                    const amount = parseFloat(obligation.obligationAmountCredit) || 0;
                    const quota = parseFloat(obligation.obligationQuota) || 0;
                    const pending = parseFloat(obligation.obligationPendingPercent) || 0;

                    if (obligation.obligationAccountType === "CAV") {
                    // Suma a obligationCAV si es de tipo "CAV"
                    obligationCAV += residue;
                    } else {
                    // Suma al total general si no es de tipo "CAV"
                    totalGeneral += residue;
                    }
                    if (obligation.obligationType === "UNID FLIAR") {
                    // Suma a obligationCAV si es de tipo "CAV"
                    obligationTotalFamiliar += amount;
                    obligationResidueFamiliar += residue;
                    obligationQuotaFamiliar += quota;
                    obligationPendingPercentFamiliar += pending;
                    countFamiliar++;
                    } else {
                    // Suma al total general si no es de tipo "CAV"
                    obligationTotalBusiness += amount;
                    obligationResidueBusiness += residue;
                    obligationQuotaBusiness += quota;
                    obligationPendingPercentBusiness += pending;
                    countBusiness++;
                    }
                });
                }
                // Calcula el promedio para pendingPercent
                // obligationPendingPercentFamiliar = countFamiliar > 0 ? obligationPendingPercentFamiliar / countFamiliar : 0;
                // obligationPendingPercentBusiness = countBusiness > 0 ? obligationPendingPercentBusiness / countBusiness : 0;
                obligationPendingPercentFamiliar = countFamiliar > 0
                ? Number((obligationPendingPercentFamiliar / countFamiliar).toFixed(2))
                : 0;
                obligationPendingPercentBusiness = countBusiness > 0
                ? Number((obligationPendingPercentBusiness / countBusiness).toFixed(2))
                : 0;

                // Asignamos el valor a una propiedad de la instancia (para poder usarlo en la vista)
                this.obligationCAV = obligationCAV;
                this.obligationTotalFamiliar = obligationTotalFamiliar;
                this.obligationResidueFamiliar = obligationResidueFamiliar;
                this.obligationQuotaFamiliar = obligationQuotaFamiliar;
                this.obligationPendingPercentFamiliar = obligationPendingPercentFamiliar;
                this.obligationTotalBusiness = obligationTotalBusiness;
                this.obligationResidueBusiness = obligationResidueBusiness;
                this.obligationQuotaBusiness = obligationQuotaBusiness;
                this.obligationPendingPercentBusiness = obligationPendingPercentBusiness;

                // Retornamos el total general (sin "CAV")
                return totalGeneral;
            },
            obligationPendingPercentComputed() {
                let term = this.obligationTerm || 0; // Asegura que no sea nulo
                let pendingQuota = this.obligationPendingQuota || 0; // Asegura que no sea nulo
                // Calcular el porcentaje de cuotas pendientes
                const percent = term > 0 ? Math.round((pendingQuota / term) * 100) : 0;

                // Almacenar el valor en this.obligationPendingPercent
                this.obligationPendingPercent = percent;

                return percent; // Retornar el valor calculado
            },
            obligationResidueCreditFlowComputed() {
                const contingentResidue = this.obligationContingentResidue || 0;
                const residue = this.obligationResidue || 0;

                // Calcular el valor máximo
                const minValue = Math.max(contingentResidue, residue);

                // Almacenar el valor en this.obligationResidueCreditFlow
                this.obligationResidueCreditFlow = minValue;

                // Retornar el valor calculado
                return minValue;
            },

            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             obligationContingentResidueComputed() {
                const clientName = this.clientType.name;

                // Buscar el objeto con el mismo nombre
                const result = this.contingentQuota.find(item => item.data.name === clientName);

                if (result) {
                    // Parsear ambos valores a float y multiplicarlos
                    const amountCredit = this.obligationAmountCredit ? parseFloat(this.obligationAmountCredit) : 0;
                    const balance = parseFloat(result.data.balance);

                    // Realizar la multiplicación y eliminar los decimales
                    this.obligationContingentResidue = Math.floor(amountCredit * balance / 100);

                    return this.obligationContingentResidue;
                } else {
                    return 0;  // Si no se encuentra el objeto, devolver 0
                }
            },
            obligationContingentQuotaComputed() {
                const clientName = this.clientType.name;

                // Buscar el objeto con el mismo nombre
                const result = this.contingentQuota.find(item => item.data.name === clientName);

                if (result) {
                    // Parsear ambos valores a float y multiplicarlos
                    const amountCredit = this.obligationAmountCredit ? parseFloat(this.obligationAmountCredit) : 0;
                    const quota = parseFloat(result.data.quota);

                    // Realizar la multiplicación y eliminar los decimales
                    this.obligationContingentQuota = Math.floor(amountCredit * quota / 100);

                    return this.obligationContingentQuota;
                } else {
                    return 0;  // Si no se encuentra el objeto, devolver 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productCostUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            // allVehiclesMonthlyCostComputed() {
            //     var sum = 0;
            //     if (this.monthlyNumber != '') {
            //         for (let i=0;i<this.actualVehicles.length;i++) {
            //             sum = sum + (this.actualVehicles[i].value * parseFloat(this.monthlyNumber));
            //         }
            //         this.alertFlag = true;
            //     }
            //     else {
            //         for (let i=0;i<this.actualVehicles.length;i++) {
            //             sum = sum + (this.actualVehicles[i].value);
            //         }
            //         if (sum != 0) {
            //             this.alertFlag = false;
            //         }
            //     }
            //     return sum
            // },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             allTravelsMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualTravels.length;i++) {
                    if (this.actualTravels[i].locked) {
                        if (flag == 0 && this.actualTravels[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualTravels[i].value)* flag);
                    }
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             allExpensesMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    if (this.actualExpenses[i].locked) {
                        if (flag == 0 && this.actualExpenses[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualExpenses[i].value)* flag);
                    }
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allVehiclesMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualVehicles.length;i++) {
                    if (this.actualVehicles[i].locked) {
                        if (flag == 0 && this.actualVehicles[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualVehicles[i].value)* flag);
                    }
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allTaxesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualTaxes.length;i++) {
                    if (this.actualTaxes[i].periodicity == 'Mensual') {
                        sum = sum + this.actualTaxes[i].value;
                    }
                    else {
                        sum = sum + (this.actualTaxes[i].value/ 12);
                    }

                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allVehiclesMonthlyCostComputed + this.allTaxesMonthlyCostComputed
            }
        },
        methods: {
            changeCreditFlow(value){
                this.manualQuotaOverride = this.obligationQuotaCreditFlow;
            },
            updateCreditFlow(){
                if (this.manualQuotaOverride !== '') {
                    return this.manualQuotaOverride;
                }
                // Si no, calcular el valor
                const contingentQuota = Number(this.obligationContingentQuota) || 0;
                const quota = Number(this.obligationQuota) || 0;
                const maxQuota = Math.max(contingentQuota, quota);
                this.obligationQuotaCreditFlow = maxQuota;
            },
            resetObligationQuotaCreditFlow() {
                // Restablecer el valor manual para que use el cálculo automático
                this.manualQuotaOverride = '';
                this.updateCreditFlow();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateObligation() {
                // Validar que no haya campos vacíos en las propiedades que NO pueden ser nulos, vacíos o 0
                if (!this.obligationType ||
                    !this.obligationEntity ||
                    !this.obligationRole ||
                    !this.obligationAccountType ||
                    !this.obligationAmountCredit ||
                    !this.obligationQuota ||
                    !this.obligationTerm ||
                    !this.obligationPendingQuota ||
                    !this.obligationPendingPercent ||
                    !this.obligationPeriodicity ||
                    !this.obligationDestiny ||
                    !this.obligationCollect ||
                    !this.obligationCreditDestiny) {
                    this.showNotificationError('La obligación no tiene los datos completamente diligenciados')
                    return false;  // Detener la ejecución si hay error
                }

                // Si no hay errores de validación, limpiar el mensaje de error
                return true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditObligationMethod (currentRow) {
                // Asigna los valores de currentRow a los campos de la obligación
                this.obligationType = currentRow.obligationType;
                this.obligationEntity = currentRow.obligationEntity;
                this.obligationRole = currentRow.obligationRole;
                this.obligationAccountType = currentRow.obligationAccountType;
                this.obligationAmountCredit = currentRow.obligationAmountCredit;
                this.obligationResidue = currentRow.obligationResidue;
                this.obligationQuota = currentRow.obligationQuota;
                this.obligationContingentResidue = currentRow.obligationContingentResidue;
                this.obligationContingentQuota = currentRow.obligationContingentQuota;
                this.obligationQuotaCreditFlow = currentRow.obligationQuotaCreditFlow;
                this.obligationResidueCreditFlow = currentRow.obligationResidueCreditFlow;
                this.obligationTerm = currentRow.obligationTerm;
                this.obligationPendingQuota = currentRow.obligationPendingQuota;
                this.obligationPendingPercent = currentRow.obligationPendingPercent;
                this.obligationPeriodicity = currentRow.obligationPeriodicity;
                this.obligationDestiny = currentRow.obligationDestiny;
                this.obligationCollect = currentRow.obligationCollect;
                this.obligationCreditDestiny = currentRow.obligationCreditDestiny;
                this.manualQuotaOverride = currentRow.manualQuotaOverride;

                // Marca el estado de edición como verdadero para abrir el modal
                this.editObligation = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showEditExpensesMethod (row) {
                this.expenseName= row.name;
                this.expenseValue= row.value;
                this.expenseLocked = row.locked;
                this.editObligation = true;
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showEditTravelsMethod (row) {
                this.travelName= row.name;
                this.travelValue= row.value;
                this.travelLocked = row.locked;
                this.editTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditTaxesMethod (row) {
                this.taxName= row.name;
                this.taxValue= row.value;
                this.taxLocked = row.locked;
                this.taxPeriodicity = row.periodicity;
                this.editTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleTravelCurrentChange(currentRow, oldCurrentRow) {
                this.currentTravelRow = currentRow;
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleExpenseCurrentChange(currentRow, oldCurrentRow) {
                this.currentExpenseRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleTaxCurrentChange(currentRow, oldCurrentRow) {
                this.currentTaxRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemPercent == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            this.products[this.addProductIndex].items.push({
                                itemName: this.itemName,
                                itemPurchasePrice: this.itemPurchasePrice,
                                itemSalePrice: this.itemSalePrice,
                                itemPercent: this.itemPercent
                            })
                            this.resetItem();
                            this.addProduct = false;
                            this.addProductIndex = null;
                            this.showNotificationSuccess('Ítem agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editObligationToList() {
                this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    if (!this.validateObligation()) {
                    return;  // Si la validación falla, no se ejecuta la edición
                    } else {
                    // Encuentra el índice de la obligación que estás editando en actualObligations
                    const obligationIndex = this.actualObligations.findIndex(obligation =>
                        obligation === this.currentRow // Asume que tienes una referencia a la obligación seleccionada
                    );

                    if (obligationIndex !== -1) {
                        // Actualiza la obligación en actualObligations con los nuevos valores
                        this.actualObligations.splice(obligationIndex, 1, {
                        obligationType: this.obligationType,
                        obligationEntity: this.obligationEntity,
                        obligationRole: this.obligationRole,
                        obligationTC: this.obligationRole ? this.obligationRole.charAt(0) : '',
                        obligationAccountType: this.obligationAccountType,
                        obligationAmountCredit: this.obligationAmountCredit,
                        obligationResidue: this.obligationResidue || 0,
                        obligationQuota: this.obligationQuota,
                        obligationContingentResidue: this.obligationContingentResidue,
                        obligationContingentQuota: this.obligationContingentQuota,
                        obligationQuotaCreditFlow: this.obligationQuotaCreditFlow,
                        obligationResidueCreditFlow: this.obligationResidueCreditFlow,
                        obligationTerm: this.obligationTerm,
                        obligationPendingQuota: this.obligationPendingQuota,
                        obligationPendingPercent: this.obligationPendingPercent,
                        obligationPeriodicity: this.obligationPeriodicity,
                        obligationDestiny: this.obligationDestiny,
                        obligationCollect: this.obligationCollect,
                        obligationCreditDestiny: this.obligationCreditDestiny,
                        manualQuotaOverride : this.manualQuotaOverride
                        });

                        // Reinicia los campos de la obligación y cierra el modal
                        this.resetObligation();
                        this.editObligation = false;
                        this.currentRow = null;
                        this.showNotificationSuccess('Obligación editada correctamente');
                    } else {
                        this.showNotificationError('Error al editar la obligación'); // Notificación en caso de error
                    }
                    }
                }
                });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var index = this.actualExpenses.indexOf(this.currentExpenseRow);
                            this.actualExpenses[index].name = this.expenseName;
                            this.actualExpenses[index].value = this.expenseValue;
                            this.resetObligation();
                            this.currentRow = null;
                            this.$refs.expensesTable.setCurrentRow();
                            this.editExpense = false;
                            this.showNotificationSuccess('Gasto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            var index = this.actualTaxes.indexOf(this.currentTaxRow);
                            this.actualTaxes[index].name = this.taxName;
                            this.actualTaxes[index].value = this.taxValue;
                            this.actualTaxes[index].periodicity = this.taxPeriodicity;
                            this.resetTax();
                            this.currentTaxRow = null;
                            this.$refs.taxesTable.setCurrentRow();
                            this.editTax = false;
                            this.showNotificationSuccess('Impuesto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addObligationMethod (row) {
                // this.addProductIndex = row;
                this.resetObligation();
                this.addObligation = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.resetExpense();
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addTravelMethod (row) {
                // this.addProductIndex = row;
                this.resetTravel();
                this.addTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxMethod (row) {
                // this.addProductIndex = row;
                this.resetTax();
                this.addTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addObligationToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (!this.validateObligation()) {
                            return;  // Si la validación falla, no se ejecuta el guardado
                        }
                        else {
                            this.obligation = {
                                obligationType: this.obligationType,
                                obligationEntity: this.obligationEntity,
                                obligationRole: this.obligationRole,
                                obligationTC: this.obligationRole ? this.obligationRole.charAt(0) : '',
                                obligationAccountType: this.obligationAccountType,
                                obligationAmountCredit: this.obligationAmountCredit,
                                obligationResidue: this.obligationResidue || 0,
                                obligationQuota: this.obligationQuota,
                                obligationContingentResidue: this.obligationContingentResidue,
                                obligationContingentQuota: this.obligationContingentQuota,
                                obligationQuotaCreditFlow: this.obligationQuotaCreditFlow,
                                obligationResidueCreditFlow: this.obligationResidueCreditFlow,
                                obligationTerm: this.obligationTerm,
                                obligationPendingQuota: this.obligationPendingQuota,
                                obligationPendingPercent: this.obligationPendingPercent,
                                obligationPeriodicity: this.obligationPeriodicity,
                                obligationDestiny: this.obligationDestiny,
                                obligationCollect: this.obligationCollect,
                                obligationCreditDestiny: this.obligationCreditDestiny,
                                manualQuotaOverride: this.manualQuotaOverride
                            };

                            this.actualObligations.push({...this.obligation});
                            this.resetObligation();
                            this.addObligation = false;
                            this.showNotificationSuccess('Obligación agregada correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var id = this.actualExpenses.length + 1;
                            this.actualExpenses.push({
                                id: id,
                                name: this.expenseName,
                                value: this.expenseValue,
                                locked: false
                            })
                            this.resetExpense();
                            this.addExpense = false;
                            this.showNotificationSuccess('Gasto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addTravelToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.travelName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var id = this.actualTravels.length + 1;
                            this.actualTravels.push({
                                id: id,
                                name: this.travelName,
                                value: this.travelValue,
                                locked: false
                            })
                            this.resetTravel();
                            this.addTravel = false;
                            this.showNotificationSuccess('Gasto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            var id = this.actualTaxes.length + 1;
                            this.actualTaxes.push({
                                id: id,
                                name: this.taxName,
                                periodicity: this.taxPeriodicity,
                                value: this.taxValue,
                                locked: false
                            })
                            this.resetTax();
                            this.addTax = false;
                            this.showNotificationSuccess('Impuesto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetObligation () {
                this.obligationType = '';
                this.obligationEntity = '';
                this.obligationRole = '';
                this.obligationAccountType = '';
                this.obligationAmountCredit = '';
                this.obligationResidue = '';
                this.obligationQuota = '';
                this.obligationContingentResidue = '';
                this.obligationContingentQuota = '';
                this.obligationQuotaCreditFlow = '';
                this.obligationResidueCreditFlow = '';
                this.obligationTerm = '';
                this.obligationPendingQuota = '';
                this.obligationPendingPercent = '';
                this.obligationPeriodicity = '';
                this.obligationDestiny = '';
                this.obligationCollect = '';
                this.obligationCreditDestiny = '';
                this.manualQuotaOverride = '';
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             resetTravel () {
                this.travelName = '';
                this.travelValue = '';
                this.travelLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetTax () {
                this.taxName = '';
                this.taxValue = '';
                this.taxPeriodicity = 'Anual';
                this.taxLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editObligationMethod (currentRow) {
                // Asigna los valores de currentRow a los campos de la obligación
                this.obligationType = currentRow.obligationType;
                this.obligationEntity = currentRow.obligationEntity;
                this.obligationRole = currentRow.obligationRole;
                this.obligationTC = currentRow.obligationRole ? currentRow.obligationRole.charAt(0) : '',
                this.obligationAccountType = currentRow.obligationAccountType;
                this.obligationAmountCredit = currentRow.obligationAmountCredit;
                this.obligationResidue = currentRow.obligationResidue;
                this.obligationQuota = currentRow.obligationQuota;
                this.obligationContingentResidue = currentRow.obligationContingentResidue;
                this.obligationContingentQuota = currentRow.obligationContingentQuota;
                this.obligationQuotaCreditFlow = currentRow.obligationQuotaCreditFlow;
                this.obligationResidueCreditFlow = currentRow.obligationResidueCreditFlow;
                this.obligationTerm = currentRow.obligationTerm;
                this.obligationPendingQuota = currentRow.obligationPendingQuota;
                this.obligationPendingPercent = currentRow.obligationPendingPercent;
                this.obligationPeriodicity = currentRow.obligationPeriodicity;
                this.obligationDestiny = currentRow.obligationDestiny;
                this.obligationCollect = currentRow.obligationCollect;
                this.obligationCreditDestiny = currentRow.obligationCreditDestiny;
                this.manualQuotaOverride = currentRow.manualQuotaOverride;

                // Marca el estado de edición como verdadero para abrir el modal
                this.editObligation = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editExpenseMethod () {
                this.expenseName= this.currentExpenseRow.name;
                this.expenseValue= this.currentExpenseRow.value;
                this.expenseLocked = this.currentExpenseRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editTravelMethod () {
                this.travelName= this.currentTravelRow.name;
                this.travelValue= this.currentTravelRow.value;
                this.travelLocked = this.currentTravelRow.locked;
                this.editTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxMethod () {
                this.taxName= this.currentTaxRow.name;
                this.taxPeriodicity= this.currentTaxRow.periodicity;
                this.taxValue= this.currentTaxRow.value;
                this.taxLocked = this.currentTaxRow.locked;
                this.editTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeObligationMethod () {
                this.actualObligations.splice(this.actualObligations.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentExpenseRow),1);
                this.currentExpenseRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeTravelMethod () {
                this.actualTravels.splice(this.actualTravels.indexOf(this.currentTravelRow),1);
                this.currentTravelRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeTaxMethod () {
                this.actualTaxes.splice(this.actualTaxes.indexOf(this.currentTaxRow),1);
                this.currentTaxRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddObligation () {
                this.addObligation = false;
                this.resetObligation();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddTravel () {
                this.addTravel = false;
                this.resetTravel();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditObligation () {
                this.editObligation = false;
                this.resetObligation();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditTravel () {
                this.editTravel = false;
                this.resetTravel();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddTax () {
                this.addTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditTax () {
                this.editTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveObligations () {
                if (this.obligationTotalComputed != 0) {
                    this.obligations.push({
                        obligations: this.actualObligations,
                        totalObligations: this.obligationTotalComputed,
                        totalTitular: this.obligationTitularComputed,
                        totalObligationsCAV: this.obligationCAV,
                        obligationTotalFamiliar: this.obligationTotalFamiliar,
                        obligationResidueFamiliar: this.obligationResidueFamiliar,
                        obligationQuotaFamiliar: this.obligationQuotaFamiliar,
                        obligationPendingPercentFamiliar: this.obligationPendingPercentFamiliar,
                        obligationTotalBusiness: this.obligationTotalBusiness,
                        obligationResidueBusiness: this.obligationResidueBusiness,
                        obligationQuotaBusiness: this.obligationQuotaBusiness,
                        obligationPendingPercentBusiness: this.obligationPendingPercentBusiness
                    })
                    // Verifica si alguna obligación no tiene "obligationTC"
                    const obligationsWithoutTC = this.obligations[0].obligations.filter(item => !('obligationTC' in item));

                    // Si encuentra alguna, crea un string con las entidades
                    if (obligationsWithoutTC.length > 0) {
                        const entities = obligationsWithoutTC.map(item => item.obligationEntity);
                        const entitiesString = entities.join(', '); // Convierte el array en un string separado por comas
                        swal({
                            title: 'Algo no está bien',
                            text: `Las siguientes obligaciones no tienen T/C: ${entitiesString}`,
                            type: 'warning',
                            showCancelButton: true,
                            showConfirmButton: false,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'Corregir',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        });
                        return
                    }
                    this.$store.dispatch('setFinancialObligations', this.obligations).then(()=>{
                        // this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                        this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                    });

                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                }

            }
        },
        mounted () {
            // this.showNotificationError('Existe un problema con la parametrización del sistema en el módulo administrativo');
            this.contingentQuota =  this.$store.getters.getContingentQuotasTdcPyme;
            if (this.$store.state.isCustomer) {
                this.clientType = this.$store.getters.getClientTypes.find(client => client.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].clientType);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations.length != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].obligations.length != 0) {
                    this.actualObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].obligations;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingVehicles != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingVehicles;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingVehicles;
                    }
                    this.expenses = Expenses;
                    this.travels = Travels;
                    this.taxes = Taxes;
                    for (let i=0; i<this.vehicles.length;i++) {
                        this.actualVehicles.push({
                            id: this.vehicles[i].id,
                            name: this.vehicles[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.travels.length;i++) {
                        this.actualTravels.push({
                            id: this.travels[i].id,
                            name: this.travels[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            frecuency: '',
                            month: 'Todos',
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.taxes.length;i++) {
                        this.actualTaxes.push({
                            id: this.taxes[i].id,
                            name: this.taxes[i].name,
                            value: 0,
                            periodicity: 'Anual',
                            locked: true
                        })
                    }
                    this.taxes = Taxes;
                }
            }
            else if(this.$store.state.isSpouse) {
                this.clientType = this.$store.getters.getClientTypes.find(client => client.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].clientType);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations.length != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].obligations.length != 0) {
                    this.actualObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].obligations;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingVehicles != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingVehicles;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingVehicles;
                    }
                    this.expenses = Expenses;
                    this.travels = Travels;
                    this.taxes = Taxes;
                    for (let i=0; i<this.vehicles.length;i++) {
                        this.actualVehicles.push({
                            id: this.vehicles[i].id,
                            name: this.vehicles[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.travels.length;i++) {
                        this.actualTravels.push({
                            id: this.travels[i].id,
                            name: this.travels[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            frecuency: '',
                            month: 'Todos',
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.taxes.length;i++) {
                        this.actualTaxes.push({
                            id: this.taxes[i].id,
                            name: this.taxes[i].name,
                            value: 0,
                            periodicity: 'Anual',
                            locked: true
                        })
                    }
                    this.taxes = Taxes;
                }
            }
            else if(this.$store.state.isGuarantor) {
                this.clientType = this.$store.getters.getClientTypes.find(client => client.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].clientType);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations.length != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].obligations.length != 0) {
                    this.actualObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].obligations;
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingVehicles != 0) {
                        this.periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingVehicles;
                        this.periodicity_days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingVehicles;
                    }
                    this.expenses = Expenses;
                    this.travels = Travels;
                    this.taxes = Taxes;
                    for (let i=0; i<this.vehicles.length;i++) {
                        this.actualVehicles.push({
                            id: this.vehicles[i].id,
                            name: this.vehicles[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.travels.length;i++) {
                        this.actualTravels.push({
                            id: this.travels[i].id,
                            name: this.travels[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            frecuency: '',
                            month: 'Todos',
                            value: 0,
                            locked: true
                        })
                    }
                    for (let i=0; i<this.taxes.length;i++) {
                        this.actualTaxes.push({
                            id: this.taxes[i].id,
                            name: this.taxes[i].name,
                            value: 0,
                            periodicity: 'Anual',
                            locked: true
                        })
                    }
                    this.taxes = Taxes;
                }
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
